module.exports = __webpack_public_path__ + "static/media/Logo.ca18b742.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Logo.png
// module id = 182
// module chunks = 0